import {
    createContext,
    PropsWithChildren,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { AssetConfigContextValue } from "./types";
import { useAssetsConfig } from "@hooks/use-config/asset";
import { initialAssetsConfigContextValue } from "./utils";
import { getTableColumnsFromFields } from "@hooks/use-config/asset/utils";

const AssetConfigContext = createContext<AssetConfigContextValue>({} as any);

export const AssetConfigContextProvider = ({ children }: PropsWithChildren) => {
    const [state, setState] = useState<AssetConfigContextValue>(
        initialAssetsConfigContextValue
    );

    const { getConfig } = useAssetsConfig();

    const hasFetchedConfig = useRef(false);
    useEffect(() => {
        const getInitialConfig = async () => {
            const config = await getConfig();
            setState({
                loading: false,
                error: null,
                config: config ?? ({} as AssetConfigContextValue["config"]),
                tableColumns: getTableColumnsFromFields(config ?? {}),
            });
        };

        if (!hasFetchedConfig.current) {
            hasFetchedConfig.current = true;
            getInitialConfig();
        }
    }, [getConfig]);

    return (
        <AssetConfigContext.Provider value={state}>
            {children}
        </AssetConfigContext.Provider>
    );
};

export const useAssetsConfigContext = () => {
    const context = useContext(AssetConfigContext);
    if (!context) {
        throw new Error(
            "useAssetsConfigContext must be used within an AssetConfigContextProvider"
        );
    }
    return context;
};
